import { useEffect } from 'react';
import { useLocation } from 'react-router';

const getRouteTitle = (pathname) => {
    const segments = pathname.split('/');

    if (segments.includes('workstation')) {
        return 'Investor Engagement Manager';
    }

    return 'Altvia Launchpad';
};

const useDocumentTitle = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        document.title = getRouteTitle(pathname);

        // Clean up on unmount
        return () => {
            document.title = 'Altvia Launchpad';
        };
    }, [pathname]);
};

export default useDocumentTitle;
